const FreeEmailProviderDomainsRaw = require('../Data/FreeEmailProviderDomains.json');

// Source: https://gist.github.com/tbrianjones/5992856/
const FreeEmailProviderDomains = new Set<string>(FreeEmailProviderDomainsRaw);

export default function isDomainOrganizationSpecific(domain: string)
{
    return !FreeEmailProviderDomains.has(domain.toLowerCase());
}